import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';
import { faCalendarAlt } from '@rtkwlf/pro-solid-svg-icons/faCalendarAlt';

export const dateTimePickerTheme: Pick<
  Components<Theme>,
  'MuiDateTimePicker'
> = {
  MuiDateTimePicker: {
    defaultProps: {
      slots: {
        openPickerIcon: () => (
          <FontAwesomeIcon icon={faCalendarAlt} size="xs" />
        ),
      },
    },
  },
};
